import React from "react";
import "./Contact.css";

const ContactPage = ({ language }) => {
  return (
    <div className="contact-container" id="contact">
      <h1 className="title" style={{ color: "#000" }}>
        YouTube
      </h1>
      <div className="video-container">
        <iframe
          width="100%"
          height="100%"
          title="youtube video"
          src="https://www.youtube.com/embed/ZdCTA5LtdVU"
          allowFullScreen
        ></iframe>
      </div>
      <h1 className="title" style={{ color: "#000" }}>
        {language.contact}
      </h1>
      <div className="social-links">
        <a href="https://wa.me/34603141447" target="_blank" rel="noreferrer">
          <i
            style={{
              color: "#24cc63",
            }}
            className="fab fa-whatsapp"
          ></i>
        </a>
        <a
          href="https://www.instagram.com/luka_rostom"
          target="_blank"
          rel="noreferrer"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "35px",
            width: "35px",
            textAlign: "center",
            color: "#fff",
            verticalAlign: "middle",
            background:
              "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)",
            boxShadow: "0px 3px 10px rgba(0,0,0,.25)",
            borderRadius: "5px",
          }}
        >
          <i className="fab fa-instagram"></i>
        </a>
        <a
          href="https://www.facebook.com/luka.cackrialashvili/"
          target="_blank"
          rel="noreferrer"
        >
          <i
            style={{
              color: "#0675e8",
            }}
            className="fab fa-facebook"
          ></i>
        </a>
        <a
          href="https://www.youtube.com/@lukarostomashvili"
          target="_blank"
          rel="noreferrer"
        >
          <i
            style={{
              color: "red",
            }}
            className="fab fa-youtube"
          ></i>
        </a>
      </div>
    </div>
  );
};

export default ContactPage;
